<script lang="ts">
  import Text from '../Text.svelte';

  export let label: string;
  export let description: string;
  export let checked: boolean;
</script>

<div class="checkbox-wrapper">
  <Text tagName="label" size="medium" for={label}>{label}:</Text>
  <Text><input id={label} type="checkbox" bind:checked /> Ja</Text>
  <Text tagName="span" size="small" color="tertiary">{description}</Text>
</div>

<style lang="scss">
  @use '../../styles/spacing';

  .checkbox-wrapper {
    display: flex;
    flex-direction: column;
    gap: spacing.$xxs;
  }
</style>
